
import { Link } from "react-router-dom";
import { cn } from "@/lib/utils";
import { useParams } from "react-router-dom";

interface SidebarLinkProps {
  to: string;
  icon: React.ElementType;
  label: string;
  isCurrent: boolean;
  badge?: React.ReactNode;
  onClick?: () => void;
}

const SidebarLink = ({
  to,
  icon: Icon,
  label,
  isCurrent,
  badge,
  onClick
}: SidebarLinkProps) => {
  const params = useParams();
  const userSlug = params.userSlug;
  
  // Se c'è uno slug utente nel parametro dell'URL e il link è per una rotta admin,
  // modifica il link per usare lo slug personalizzato
  let linkTo = to;
  if (userSlug && to.startsWith('/admin/')) {
    linkTo = to.replace('/admin/', `/${userSlug}/`);
  }

  return (
    <Link to={linkTo} className="w-full block" onClick={onClick}>
      <div className={cn("flex items-center gap-3 px-4 py-3 rounded-lg text-sm font-medium transition-all", 
        isCurrent ? "bg-primary/10 text-primary shadow-sm" : "text-gray-600 hover:text-gray-900 hover:bg-gray-100")}>
        <Icon size={18} className={cn(isCurrent ? "text-primary" : "text-gray-500")} />
        <span>{label}</span>
        {badge}
      </div>
    </Link>
  );
};

export default SidebarLink;
